export default __webpack_public_path__ + "static/media/Auction_House_Banner.7dfd8ebf.png";